import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { IpelinkesComponent } from './ipelinkes/ipelinkes.component';
import { IpelandingComponent } from './ipelanding/ipelanding.component';
import { IpeTestCreationComponent } from './ipe-test-creation/ipe-test-creation.component';

const routes: Routes = [
  {
    path: '',
    component: IpelinkesComponent,
    children: [
      {
        path: 'IpeMarks',
        component: IpelandingComponent
      },
      {
        path: 'IpeTestCreation',
        component: IpeTestCreationComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IpemarkesRoutingModule { }
